import React, { useState } from 'react';
import { AdminProvider, useAdmin } from '../../context/AdminContext';
import AdminAuth from './AdminAuth';
import AdminSidebar from './AdminSidebar';
import Dashboard from './Dashboard';
import OrdersAdmin from './OrdersAdmin';
import DepositsAdmin from './DepositsAdmin';
import ProductsAdmin from './ProductsAdmin';
import UsersAdmin from './UsersAdmin';
import PaymentsAdmin from './PaymentsAdmin';
import SettingsAdmin from './SettingsAdmin';
import SupportAdmin from './SupportAdmin';
import { Toaster } from '../../components/ui/toaster';

const AdminShell = () => {
  const { token, loading } = useAdmin();
  const [page, setPage] = useState('dashboard');

  if (loading && token) {
    return <div className="min-h-screen w-full flex items-center justify-center bg-[#050505] text-[#7a7a7a] font-mono text-sm">Loading admin panel…</div>;
  }

  if (!token) return <AdminAuth />;

  const renderPage = () => {
    switch (page) {
      case 'dashboard': return <Dashboard />;
      case 'orders': return <OrdersAdmin />;
      case 'deposits': return <DepositsAdmin />;
      case 'support': return <SupportAdmin />;
      case 'products': return <ProductsAdmin />;
      case 'users': return <UsersAdmin />;
      case 'payments': return <PaymentsAdmin />;
      case 'settings': return <SettingsAdmin />;
      default: return <Dashboard />;
    }
  };

  return (
    <div className="min-h-screen w-full bg-[#050505] text-[#e6e6e6] flex">
      <AdminSidebar page={page} setPage={setPage} />
      <main className="flex-1 min-w-0">{renderPage()}</main>
    </div>
  );
};

const AdminApp = () => (
  <AdminProvider>
    <AdminShell />
    <Toaster />
  </AdminProvider>
);

export default AdminApp;
